import { elvis } from './elvis.operator';

// Should be either a query/mutation with a invalid-jwt error
// or a subscription with a JWTExpired error
export const isKnownJwtError = error =>
  elvis(error, 'error.errors.0.extensions.code') === 'invalid-jwt' ||
  ((error && error.originalError) || '').toString().endsWith('JWTExpired');
